import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_base_button = _resolveComponent("base-button")
  const _component_progress_overlay = _resolveComponent("progress-overlay")

  return (!$options.userIsFollowingProject)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default", { onSubscribe: $options.onSubscribe }, () => [
          _createVNode(_component_base_button, {
            theme: $props.theme,
            class: "_flex _gap-2 gfu-1of1 _jc-sb",
            "aria-label": _ctx.Resources.ProjectHome.FollowProjectButton,
            onClick: _withModifiers($options.onSubscribe, ["prevent"]),
            "data-qa": "follow-project-button"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_base_icon, {
                name: "heart-solid-icon",
                "icon-namespace": "ga"
              }),
              _createTextVNode(" " + _toDisplayString(_ctx.Resources.ProjectHome.FollowProjectButton) + " ", 1 /* TEXT */),
              (!$props.isStacked)
                ? (_openBlock(), _createBlock(_component_base_icon, {
                    key: 0,
                    name: "heart-solid-icon",
                    "icon-namespace": "ga",
                    class: "is-invisible"
                  }))
                : _createCommentVNode("v-if", true)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["theme", "aria-label", "onClick"])
        ]),
        ($props.showOverlay)
          ? (_openBlock(), _createBlock(_component_progress_overlay, {
              key: 0,
              visible: _ctx.isFollowRequestProcessing,
              "minimum-visible-time": 0
            }, null, 8 /* PROPS */, ["visible"]))
          : _createCommentVNode("v-if", true)
      ]))
    : _createCommentVNode("v-if", true)
}